<template>
    <div class="status-badge-wrapper flex">
        <button
            @click="!active ? $emit('click') : ''"
            v-if="selectedStatus"
            :disabled="loading || disabled"
            class="py-1 px-3 rounded-full font-semibold outline outline-2"
            :class="[
                selectedStatus.textColorClass,
                active ? 'cursor-default ' + selectedStatus.bgColorClass + ' ' + selectedStatus.borderColorClass : '',
                disabled ? 'outline-grey/[0.4] text-grey/[0.4]' : '',
            ]"
        >
            <div class="flex">
                <span v-if="loading">Loading...</span>
                <InlineSvg
                    v-if="selectedStatus.icon && !loading"
                    class="self-center -ml-1 mr-2"
                    :src="global.app.url + '/images/icons/status/' + selectedStatus.icon + '.svg'"
                ></InlineSvg>
                {{ selectedStatus.label }}
            </div>
        </button>
    </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import { mapGetters } from "vuex";
export default {
    name: "ButtonStatusComponent",
    props: {
        status: { type: String, default: "" }, // Sets the "status" for the badge
        active: { type: Boolean, default: false }, // Shows the active state of the button
        loading: { type: Boolean, default: false }, // Set the loading state of the button
        disabled: { type: Boolean, default: false },
    },
    components: {
        InlineSvg,
    },
    computed: {
        ...mapGetters(["global", "collections"]),
    },
    mounted() {
        this.getStatus();
    },
    data: function () {
        return {
            selectedStatus: false,
        };
    },
    methods: {
        getStatus() {
            // Basic check to see if the status passed in via a prop exists as a valid status that we're expecting
            if (this.collections.submission_statuses[this.status] != undefined) {
                this.selectedStatus = this.collections.submission_statuses[this.status];
                this.selectedStatus.label = this.status;
            }
        },
    },
};
</script>
